import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="max-w-md w-full border border-[#EF4444] bg-white p-6">
          <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#EF4444] mb-2">
            Something went wrong
          </div>
          <h2 className="font-heading font-black text-3xl tracking-tighter text-[#111827] mb-3">
            This page hit an error.
          </h2>
          <p className="text-sm text-[#374151] mb-4">
            {String(this.state.error?.message || this.state.error || "Unknown error")}
          </p>
          <div className="flex gap-2">
            <button onClick={this.reset} data-testid="error-retry"
                    className="bg-[#002FA7] text-white font-bold px-4 py-2 hover:bg-[#002280]">
              Try again
            </button>
            <button onClick={() => (window.location.href = "/")} data-testid="error-home"
                    className="border border-[#D1D5DB] font-bold px-4 py-2 hover:bg-[#F3F4F6]">
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
